// extracted by mini-css-extract-plugin
export var rateTable = "_48-0";